import { useState, useRef } from "react";
import api, { apiError } from "../../lib/api";
import { toast } from "sonner";
import Turnstile, { TURNSTILE_ENABLED } from "../../components/Turnstile";

export default function ContactSection() {
  const [f, setF] = useState({ name: "", email: "", organization: "", message: "" });
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);
  const [token, setToken] = useState("");
  const tsRef = useRef(null);

  const submit = async () => {
    setBusy(true);
    try {
      await api.post("/public/contact", { ...f, turnstile_token: token });
      setSent(true);
      setF({ name: "", email: "", organization: "", message: "" });
      setToken("");
      tsRef.current?.reset();
    } catch (e) { toast.error(apiError(e)); setToken(""); tsRef.current?.reset(); } finally { setBusy(false); }
  };

  const needsToken = TURNSTILE_ENABLED;

  return (
    <section className="hairline py-16 rise" data-testid="contact-section" id="contact">
      <div className="grid lg:grid-cols-[1fr_1.1fr] gap-16">
        <div>
          <span className="t-label">Contact</span>
          <h2 className="text-bone mt-4 measure" style={{ fontSize: "34px", lineHeight: 1.1, letterSpacing: "-0.01em" }}>
            Write to Solera
          </h2>
          <p className="t-small text-muted-s mt-4 measure">
            Solera is private and access is by referral. If you are a shareholder, a broker or an
            allocator and believe there is a fit, tell us plainly. We read every message.
          </p>
          <p className="t-cap text-muted-s mt-6 fig">contact@solera.vc</p>
        </div>
        <div className="p-8" style={{ background: "#14171A", border: "1px solid #24272B" }}>
          {sent ? (
            <div data-testid="contact-success">
              <span className="t-label">Received</span>
              <p className="t-body text-bone mt-3 measure">
                Thank you. Your message has reached us and a member of the team will respond
                directly. We have sent a confirmation to your email.
              </p>
            </div>
          ) : (
            <div className="space-y-3">
              <input className="input-solera" placeholder="Name" value={f.name}
                onChange={(e) => setF({ ...f, name: e.target.value })} data-testid="contact-name-input" />
              <input className="input-solera" placeholder="Email" type="email" value={f.email}
                onChange={(e) => setF({ ...f, email: e.target.value })} data-testid="contact-email-input" />
              <input className="input-solera" placeholder="Organization (optional)" value={f.organization}
                onChange={(e) => setF({ ...f, organization: e.target.value })} data-testid="contact-org-input" />
              <textarea className="input-solera" rows={5} placeholder="Your message" value={f.message}
                onChange={(e) => setF({ ...f, message: e.target.value })} data-testid="contact-message-input" />
              <Turnstile ref={tsRef} onToken={setToken} />
              <button className="btn-primary" disabled={busy || !f.name || !f.email || !f.message || (needsToken && !token)}
                onClick={submit} data-testid="contact-submit-button">
                {busy ? "Sending" : "Send message"}
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
